import * as React from 'react';
import { Tag, Space, Typography } from '@sravni/react-design-system';
import { useBoolean, useStyles } from '@sravni/react-utils';
import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { defaultLink, defaultDateTo, defaultActivePeriod } from '../constants/defaultParams.js';
import modules_94312347 from '../styles/SberPromo.module.less.js';
import { SberSlogan } from './SberSlogan.js';

const { Text, Link } = Typography;
const getCountDownString = (dateTo) => {
    const delta = Math.floor((dateTo.getTime() - new Date().getTime()) / 1000);
    const days = Math.floor(delta / 3600 / 24);
    const hours = Math.floor((delta - days * 3600 * 24) / 3600);
    const minutes = Math.floor((delta - days * 3600 * 24 - hours * 3600) / 60);
    const seconds = Math.floor(delta - days * 3600 * 24 - hours * 3600 - minutes * 60);
    const dayPluralize = pluralizeByUnit(days, 'day');
    if ((days === 0 && hours === 0 && minutes === 0 && seconds === 0) || days < 0)
        return null;
    return `${days} ${dayPluralize} ${hours} ч ${minutes} м ${seconds} с`;
};
const checkCurrentDate = (activePeriod) => {
    const now = new Date();
    return {
        passedDate: activePeriod.to <= now,
        activeDate: activePeriod.from <= now && activePeriod.to >= now,
    };
};
/**
 * @description SberPromo component.
 *
 * @component
 * @example
 * ```jsx
 * <SberPromo />
 * ```
 */
const SberPromo = React.forwardRef((props, ref) => {
    const { href = defaultLink, dateTo = defaultDateTo, activePeriod = defaultActivePeriod, className, ...restProps } = props;
    const [countDownString, setCountDownString] = React.useState('');
    const [isActivePeriod, setIsActivePeriod] = useBoolean();
    const cx = useStyles(modules_94312347);
    const container = cx(className, 'container', 'important');
    React.useEffect(() => {
        const timer = setInterval(() => {
            const { passedDate, activeDate } = checkCurrentDate(activePeriod);
            activeDate ? setIsActivePeriod.on() : setIsActivePeriod.off();
            passedDate && clearTimeout(timer);
            setCountDownString(getCountDownString(dateTo));
        }, 1000);
        return () => clearTimeout(timer);
    }, []);
    return isActivePeriod ? (React.createElement(Link, { "data-qa": 'SberPromo', "data-element": 'header-promo', href: href, target: '_blank' },
        React.createElement(Tag, { ref: ref, className: container, size: 36, ...restProps },
            React.createElement(Space, { direction: 'vertical', align: 'center' },
                React.createElement(SberSlogan, null),
                React.createElement(Text, { size: 10, className: cx('fixedColor', { countDownString }) }, countDownString))))) : null;
});
SberPromo.defaultProps = {
    href: defaultLink,
    dateTo: defaultDateTo,
    activePeriod: defaultActivePeriod,
};

export { SberPromo as default };
//# sourceMappingURL=SberPromo.js.map
